import React, { useEffect, useState } from "react";
import { BsChevronRight } from "react-icons/bs";
import { useClassNames } from "../../../utils/useClassNames";
import styles from "./styles.module.scss";

type ToggleSectionProps = {
  title: string;
  className?: string;
  style?: React.CSSProperties;
};

const ToggleSection: React.FC<React.PropsWithChildren<ToggleSectionProps>> = ({
  style,
  title,
  children,
  ...props
}) => {
  const containerClassName = useClassNames(
    styles["Container"],
    props.className
  );
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (window.location.pathname.includes("/product/")) {
      setIsOpen(false);
    }
  }, []);

  return (
    <div className={containerClassName} style={style}>
      <b
        className={styles.Title}
        style={
          !isOpen
            ? {
                borderTop: "1px solid #d7d7d7",
                borderBottom: "1px solid #d7d7d7",
              }
            : null
        }
        onClick={() => setIsOpen(!isOpen)}
      >
        {title} {!isOpen && <BsChevronRight size={26} color={"#1C1C1E"} />}
      </b>
      <div
        className={styles["Content"]}
        style={!isOpen ? { display: "none" } : null}
      >
        {children}
      </div>
    </div>
  );
};

export default ToggleSection;
